<template functional>
  <div :class="$style.block">
    <div :class="[$style.blockHeader, props.headerClass]">
      <h4 :class="$style.blockTitle">{{ props.title }}</h4>
      <div class="ml-auto">
        <slot name="header-right" />
      </div>
    </div>
    <div :class="$style.blockBody">
      <slot />
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
	name: "IndexBlock",
	props: {
		title: String,
    headerClass: String
	}
});
</script>
<style lang="scss" module>
.block {
  margin-bottom: 1rem;
}
.blockHeader {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.blockTitle {
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>